<div class="no-data">
  <i class="fa-solid fa-inbox"></i>
  <div>{{ message }}</div>
</div>
